/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import { useTranslation } from 'react-i18next';
import { Anchor, BodyText, Heading, Size } from '@vaisala-rockhopper/components';
import { ModalInstance, ModalProps } from './Modals';
import './Modals.scss';

export const HelpModal = (props: ModalProps) => {
  const { t } = useTranslation('a-parameter-calculator');
  return (
    <ModalInstance modalId="modal.help" {...props} title={t('ui.help')} size={Size.L}>
      <Heading level={4}>{t('modalHeading.help')}</Heading>
      <BodyText>{t('modalText.help1')} </BodyText>
      <BodyText>
        {t('modalText.help2')}{' '}
        <Anchor
          to="https://www.vaisala.com/system/files/documents/vH2O2-Biodecontamination-Condensation-White-Paper-B212381EN.pdf"
          openInNewWindow={true}
        >
          &nbsp;Influences of condensation in vH2O2 bio-decontamination
        </Anchor>{' '}
      </BodyText>
      <BodyText>{t('modalText.help3')} </BodyText>
      <BodyText>
        <b>{t('modalText.disclaimer')}</b>
      </BodyText>

      <BodyText>
        {t('modalText.theory')}
        <Anchor
          to="https://www.vaisala.com/system/files/documents/VIM-GLO-IND-H2O2-Conversions-Formulas-Technical-eBook-B212206EN.pdf"
          openInNewWindow={true}
        >
          &nbsp;H<sub>2</sub>O<sub>2</sub> conversions
        </Anchor>
      </BodyText>
      <BodyText>
        {t('modalText.feedback')}
        <Anchor to="mailto:humiditycalculator@vaisala.com" openInNewWindow={true}>
          &nbsp;humiditycalculator@vaisala.com
        </Anchor>
      </BodyText>
    </ModalInstance>
  );
};
